import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import InputField from 'forms/shared/fields/input'
import SelectDropdownField from 'forms/shared/fields/dropdown'
import ContactField from 'forms/shared/fields/contact';
import AvatarField from 'forms/shared/fields/avatar'

const ProfileFields = ({ form, placesOptions }) => (
  <>
    <AvatarField form={form} />
    <Field
      type="text"
      name="name"
      groupClassName="my-4"
      placeHolder="Organization Name"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="text"
      name="address"
      groupClassName="my-4"
      placeHolder="Main Address"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="dropdown"
      name="place"
      options={placesOptions}
      placeholder={'Location'}
      groupClassName="my-4"
      inputClassName="pl-2 pt-2 regular text-xs"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={SelectDropdownField}
    />
    <Field
      type="text"
      name="email"
      groupClassName="my-4"
      placeHolder="Email"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="tel"
      name="phone"
      groupClassName="my-4"
      placeHolder="Contact Number"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={ContactField}
    />
    <Field
      type="text"
      name="website"
      groupClassName="my-4"
      placeHolder="Website URL"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="text"
      name="description"
      groupClassName="my-4"
      placeHolder="Description/About Us"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
  </>
);

ProfileFields.propTypes = {
  form: PropTypes.string,
  placesOptions: PropTypes.array,
}

export default ProfileFields;
